function checkCollision(container, element) {
  const isIntersecting = (
    (container.top > element.top && container.bottom > element.bottom)
    || (container.top < element.top && container.bottom < element.bottom)
    || (container.left > element.left && container.right > element.right)
    || (container.left < element.left && container.right < element.right)
  );

  const isOutOfBounds = (
    (element.bottom < container.top)
    || (element.top > container.bottom)
    || (container.left > element.right)
    || (container.right < element.left)
  );

  const heightDiff = element.bottom - container.bottom;
  const sideDiff = element.left - container.left;

  let xOverlap;
  let yOverlap;

  if (isIntersecting) {
    if (element.right > container.right) {
      xOverlap = 'right';
    } else if (element.left < container.left) {
      xOverlap = 'left';
    }

    if (element.top < container.top) {
      yOverlap = 'top';
    } else if (element.bottom > container.bottom) {
      yOverlap = 'bottom';
    }
  }

  return {
    isIntersecting,
    isOutOfBounds,
    heightDiff,
    sideDiff,
    xOverlap,
    yOverlap,
    isInBounds: !isIntersecting && !isOutOfBounds,
  };
}

function rectToObj(domRect) {
  const {
    top,
    right,
    bottom,
    left,
    width,
    height,
    x,
    y,
  } = domRect;

  return {
    top,
    right,
    bottom,
    left,
    width,
    height,
    x,
    y,
  };
}

export default function calculatePlacement(
  toolSelector,
  containerSelector,
  highlightSelector,
  stageSelector,
) {
  const coords = {
    x: null,
    y: null,
  };

  const tool = document.querySelector(toolSelector);
  const contextContainer = document.querySelector(containerSelector);
  const stageBounds = rectToObj(document.querySelector(stageSelector).getBoundingClientRect());

  if (tool && contextContainer) {
    // create bounds for container and tool
    const containerBounds = rectToObj(contextContainer.getBoundingClientRect());
    const toolBounds = rectToObj(tool.getBoundingClientRect());

    // create bounds for highlight
    let selectionBounds;
    const highlightedElement = document.querySelector(highlightSelector);
    if (highlightedElement) {
      selectionBounds = rectToObj(highlightedElement.getBoundingClientRect());
    } else {
      // grab the selection
      const selection = window.getSelection();
      if (selection) {
        selectionBounds = rectToObj(selection.getRangeAt(0).getBoundingClientRect());
      }
    }

    // if for some reason we couldn't get a selection, bail
    if (!selectionBounds) return coords;

    // get collision
    const collision = checkCollision(containerBounds, toolBounds);

    if (collision.isIntersecting) {
      // start with the current values for the tool
      coords.x = toolBounds.left;
      coords.y = toolBounds.top;

      if (collision.yOverlap === 'top') {
        // intersection is at the top, so move below the selection
        coords.y = selectionBounds.bottom + 10;
      } else if (collision.yOverlap === 'bottom') {
        // intersection is at the bottom, so move above the selection
        coords.y = selectionBounds.top - (toolBounds.bottom - toolBounds.top) - 10;
      }

      if (collision.xOverlap === 'left') {
        // intersection is at the left, so move to the right of the selection
        coords.x = selectionBounds.right + 50;
      } else if (collision.xOverlap === 'right') {
        // intersection is at the right, so move to the left of the selection
        coords.x = selectionBounds.left - (toolBounds.right - toolBounds.left) - 10;
      }

      // finally, if we're vertically outside of the bounds of the container, bring it in
      if (coords.x && coords.x < containerBounds.left) {
        coords.x = containerBounds.left;
      } else if (coords.x && coords.x + toolBounds.width > containerBounds.right) {
        coords.x = containerBounds.right - toolBounds.width;
      }

      // do the same with horizontal bounds
      if (coords.y && coords.y < containerBounds.top) {
        coords.y = containerBounds.top;
      } else if (coords.y && coords.y + toolBounds.height > containerBounds.bottom) {
        coords.y = containerBounds.right - toolBounds.height;
      }

      // add stage offset and clean up decimals
      if (coords.x) coords.x = Math.round(coords.x - stageBounds.left, 0);
      if (coords.y) coords.y = Math.round(coords.y - stageBounds.top, 0);
    }
  }
  return coords;
}
